import{O as o,d as r}from"./order-overview-component2.js";const e=o,s=r;export{e as OrderOverviewComponent,s as defineCustomElement}